import React from 'react';
import { Icon, Typography } from 'components/atoms';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  onItemsPerPageChange: (itemsPerPage: number) => void;
}

export const EmployeeReviewPagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  itemsPerPage,
  totalItems,
  onPageChange,
  onItemsPerPageChange,
}) => {
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className="employee-review-pagination">
      <div className="pagination-section">
        <Typography type="small_regular" text="Results Per Page" color="gray" />
        <select
          className="results-per-page-dropdown"
          onChange={(e) => onItemsPerPageChange(parseInt(e.target.value))}
          value={itemsPerPage}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={15}>15</option>
          <option value={20}>20</option>
        </select>
      </div>
      
      <div className="pagination-info">
        <Typography 
          type="small_regular" 
          text={`Showing ${startItem}-${endItem} of ${totalItems} results`} 
          color="gray" 
        />
      </div>

      <div className="pagination-section">
        {/* First page button */}
        {currentPage === 1 ? (
          <Icon type="white" src="/icons/double_arrow.svg" disabled={true} />
        ) : (
          <Icon
            type="secondary"
            src="/icons/double_arrow.svg"
            onClick={() => onPageChange(1)}
          />
        )}

        <Typography
          type="small_regular"
          color="gray"
          text={`Page ${currentPage} of ${totalPages}`}
        />

        {/* Previous page button */}
        {currentPage === 1 ? (
          <Icon type="white" src="/icons/left_arrow.svg" disabled={true} />
        ) : (
          <Icon
            type="secondary"
            src="/icons/left_arrow.svg"
            onClick={() => onPageChange(currentPage - 1)}
          />
        )}

        {/* Next page button */}
        {currentPage >= totalPages ? (
          <Icon type="white" src="/icons/right_arrow.svg" disabled={true} />
        ) : (
          <Icon
            type="secondary"
            src="/icons/right_arrow.svg"
            onClick={() => onPageChange(currentPage + 1)}
          />
        )}
      </div>
    </div>
  );
}; 